// extracted by mini-css-extract-plugin
export default {"legend_container":"CustomBarChart_legend_container__V14zP"};